export const locale = {
    lang: 'en',
    data: {
        'USERS': {
            'TITLE': 'Users'
        }
    }
};



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/users/i18n/en.ts